module.exports = __webpack_public_path__ + "static/media/default-avatar.82787765.png";